import { motion } from "framer-motion";
import { Plane, MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { MILESTONES } from "@/data/site";

export function FinalVision() {
  return (
    <section data-testid="final-vision" className="relative bg-navy-deep text-warm py-32 overflow-hidden">
      <div className="spotlight absolute inset-0 pointer-events-none" />
      <div className="max-w-5xl mx-auto px-6 text-center relative">
        <Reveal>
          <p className="accent-eyebrow text-gold">The journey, complete</p>
        </Reveal>

        {/* Connected timeline */}
        <div className="mt-14 relative flex items-center justify-between max-w-3xl mx-auto">
          <div className="absolute left-0 right-0 top-1/2 h-px bg-warm/15" />
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "100%" }}
            viewport={{ once: true }}
            transition={{ duration: 2, ease: "easeInOut" }}
            className="absolute left-0 top-1/2 h-px bg-gold"
          />
          {MILESTONES.map((m, i) => (
            <motion.span
              key={m.n}
              initial={{ scale: 0, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.18, duration: 0.4 }}
              className="relative z-10 h-2.5 w-2.5 rounded-full bg-gold"
            />
          ))}
          <motion.div
            initial={{ left: 0 }}
            whileInView={{ left: "100%" }}
            viewport={{ once: true }}
            transition={{ duration: 2, ease: "easeInOut" }}
            className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 z-20"
          >
            <Plane className="h-6 w-6 text-terracotta" style={{ transform: "rotate(90deg)" }} />
          </motion.div>
        </div>

        <Reveal delay={0.2}>
          <h2 className="font-playfair text-4xl md:text-6xl mt-20 leading-[1.1]">
            From your first idea… <br />
            to building your future in Portugal.
          </h2>
          <p className="text-warm/60 text-xl mt-8 max-w-2xl mx-auto leading-relaxed">
            Effizent Europe is with you every step of the way.
          </p>
          <div className="mt-8 inline-flex items-center gap-2 text-gold">
            <MapPin className="h-5 w-5" /> <span className="text-sm tracking-widest">DESTINATION: PORTUGAL</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
